import MPAEditCustomer from './MPAEditCustomer';

export default MPAEditCustomer;
